import {
  ActivatedRoute,
  CanActivateChildFn,
  CanActivateFn,
  Router,
} from '@angular/router';
import { inject } from '@angular/core';
import { UserContextService } from '../services/user-context.service';
import { OAuthService } from 'angular-oauth2-oidc';

export const createConnectedGuard = (
  redirectPath: string[] = ['/auth/login'],
  relativeToParent: boolean = false,
): CanActivateFn | CanActivateChildFn => {
  return async (route, state) => {
    const oauthService = inject(OAuthService);
    const userContext = inject(UserContextService);
    const router = inject(Router);

    let redirectPath2 = [...redirectPath];

    if (relativeToParent) {
      redirectPath2 = [
        ...state.url.split('/').filter(Boolean).slice(0, -1),
        ...redirectPath2,
      ];
    }

    try {
      const token = oauthService.getAccessToken();

      if (!token) {
        return router.createUrlTree(redirectPath2);
      }

      const tokenIsValid = oauthService.hasValidAccessToken();

      if (!tokenIsValid) {
        return router.createUrlTree(redirectPath2);
      }

      const user = await userContext.reloadCurrentUserIfNull();

      if (user == null) {
        return router.createUrlTree(redirectPath2);
      }

      return true;
    } catch (e) {
      return router.createUrlTree(redirectPath2);
    }
  };
};

export const createConnectedAndCompleteAccountGuard = (
  redirectPath: string[] = ['/auth/login'],
  relativeToParent: boolean = false,
): CanActivateFn | CanActivateChildFn => {
  return async (route, state) => {
    const oauthService = inject(OAuthService);
    const userContext = inject(UserContextService);
    const router = inject(Router);

    let redirectPath2 = [...redirectPath];

    if (relativeToParent) {
      redirectPath2 = [
        ...state.url.split('/').filter(Boolean).slice(0, -1),
        ...redirectPath2,
      ];
    }

    try {
      const token = oauthService.getAccessToken();

      if (!token) {
        return router.createUrlTree(redirectPath2);
      }

      const tokenIsValid = oauthService.hasValidAccessToken();

      if (!tokenIsValid) {
        return router.createUrlTree(redirectPath2);
      }

      const user = await userContext.reloadCurrentUserIfNull();

      if (user == null) {
        return router.createUrlTree(redirectPath2);
      }

      return true;
    } catch (e) {
      return router.createUrlTree(redirectPath2);
    }
  };
};

export const createConnectedWithAdminRoleGuard = (
  redirectPath: string[] = ['/auth/login'],
  relativeToParent: boolean = false,
): CanActivateFn | CanActivateChildFn => {
  return async (route, state) => {
    const oauthService = inject(OAuthService);
    const userContext = inject(UserContextService);
    const router = inject(Router);

    let redirectPath2 = [...redirectPath];

    if (relativeToParent) {
      redirectPath2 = [
        ...state.url.split('/').filter(Boolean).slice(0, -1),
        ...redirectPath2,
      ];
    }

    try {
      const token = oauthService.getAccessToken();

      if (!token) {
        return router.createUrlTree(redirectPath2);
      }

      const tokenIsValid = oauthService.hasValidAccessToken();

      if (!tokenIsValid) {
        return router.createUrlTree(redirectPath2);
      }

      const user = await userContext.reloadCurrentUserIfNull();

      if (user == null) {
        return router.createUrlTree(redirectPath2);
      }

      const isAdmin = user.roles!.some((r) => r === 'ROLE_ADMIN');

      if (!isAdmin) {
        return router.createUrlTree(redirectPath2);
      }

      return true;
    } catch (e) {
      return router.createUrlTree(redirectPath2);
    }
  };
};
